import template from './importDataRevert.template.html';

/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  $state,
  $timeout,
  $mdDialog,
  webpage,
  authenticationService,
  dateTimeService,
  fileFactory,
  importService,
  importFieldsService,
  workflowsService,
  accountsService,
  listServiceNew,
  jsonFactory,
  uiService,
  IMPORT,
  ACCOUNT,
  INSTANCE
) => {
  $scope.Model = {
    instance: INSTANCE,
    isOrganizationOwner: authenticationService.isOwner(),
    allImports: [],
    availableImports: [],
    availableTicketAndContactImports: [],
    availableMergeFields: [],
    availableWorkflows: [],
    availableAccounts: [],
    importData: [],
    importSampleTitle: [],
    importSampleData: [],
    mappableFields: [],
    mergeFieldsProperties: [],
    activeSection: 0,
    timeZones: [],
    import: {},
    blankImport: {
      id: '',
      name: '',
      file: '',
      workflow: null,
      dateFormat:
        $rootScope.CurrentOrganization.organization.dateFormat !== ''
          ? $rootScope.CurrentOrganization.organization.dateFormat
          : $rootScope.CurrentDateFormatPrimary(),
      timeFormat:
        $rootScope.CurrentOrganization.organization.timeFormat !== ''
          ? $rootScope.CurrentOrganization.organization.timeFormat
          : $rootScope.CurrentTimeFormat(),
      timezone:
        $rootScope.CurrentOrganization.organization.timezone !== ''
          ? $rootScope.CurrentOrganization.organization.timezone
          : $rootScope.CurrentTimeZone(),
      ticket: [],
      person: [],
      company: [],
      note: [],
      job: [],
      account: [],
      type: ''
    },
    upload: {
      url: IMPORT.API.UPLOAD,
      allowMultiple: IMPORT.LIMITS.MULTIPLE,
      allowedMimeTypes: IMPORT.LIMITS.ALLOWED_MIME,
      allowedExtensions: IMPORT.LIMITS.ALLOWED_EXTENSIONS
    },
    importLimitTo: 3,
    importTitle: '',
    isImportTicketsContacts: false,
    isImportNotes: false,
    isImportJobs: false,
    isImportAccounts: false,
    isUploadReady: false,
    isImportInProgress: false,
    isImportReady: false,
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');

  const getAvailableZones = () => {
    jsonFactory.getZones().then((data) => {
      $scope.Model.timeZones = _.filter(data.zones, (zone) =>
        $rootScope.CurrentOrganization.organization.address.countryCode
          ? zone.countryCodes.includes(
              $rootScope.CurrentOrganization.organization.location.cca2
            )
          : true
      );
    });
  };

  const getAvailableImports = () => {
    const deferred = $q.defer();
    importService.getAvailable({ isActive: true }).then((importData) => {
      $scope.Model.allImports = importData;
      deferred.resolve(importData);
    });
    return deferred.promise;
  };

  const preInitialize = () => {
    getAvailableZones();
    getAvailableImports().then(() => {
      $scope.list = new listServiceNew.List();
      $scope.list.clear();
      $scope.Model.isImportInProgress =
        _.find($scope.Model.allImports, { isInProgress: true }) !== undefined;
      $timeout(() => {
        webpage.pageTitle('Import data : Settings');
        $scope.Model.isReady = true;
      });
    });
  };

  preInitialize();

  $scope.hasAnyImportedFileCompleted = () =>
    _.some(
      _.filter($scope.Model.allImports, (i) => i?.type === 'ticketAndContact'),
      (i) => i?.isCompleted
    );

    $scope.selectedImport = (selectedImport) => {
      if ($rootScope.CurrentAccount.isAdministrator) {
        switch (selectedImport) {
          case 'ticketAndContact':
            $scope.Model.isImportTicketsContacts = true;
            $scope.Model.isImportNotes = false;
            $scope.Model.isImportJobs = false;
            $scope.Model.isImportAccounts = false;
            $scope.Model.importTitle = 'Deals and contacts';
            $scope.Model.importType = 'ticketAndContact';
            $scope.initialize({
              isTicket: true,
              isPerson: true,
              isCompany: true
            });
            break;
          case 'note':
            $scope.Model.isImportTicketsContacts = false;
            $scope.Model.isImportNotes = true;
            $scope.Model.isImportJobs = false;
            $scope.Model.isImportAccounts = false;
            $scope.Model.importTitle = 'Notes';
            $scope.Model.importType = 'note';
            $scope.initialize({ isNote: true });
            break;
          case 'job':
            $scope.Model.isImportTicketsContacts = false;
            $scope.Model.isImportNotes = false;
            $scope.Model.isImportJobs = true;
            $scope.Model.isImportAccounts = false;
            $scope.Model.importTitle = 'Tasks';
            $scope.Model.importType = 'job';
            $scope.initialize({ isJob: true });
            break;
          case 'account':
            $scope.Model.isImportTicketsContacts = false;
            $scope.Model.isImportNotes = false;
            $scope.Model.isImportJobs = false;
            $scope.Model.isImportAccounts = true;
            $scope.Model.importTitle = 'Users';
            $scope.Model.importType = 'account';
            $scope.initialize({ isAccount: true });
            break;
          default:
            break;
        }
        $scope.Model.isReady = false;
      }
    };

    $scope.initialize = ({ isTicket, isPerson, isCompany, isNote, isJob, isAccount }) => {
      $scope.Model.availableImports = [];
      $q.all([
        importFieldsService.getFields(isTicket, isPerson, isCompany, isNote, isJob, isAccount),
        workflowsService.getAvailable({ isActive: true }),
        accountsService.getAvailable({ isActive: true, fields: ACCOUNT.FIELDS.CHIPS })
      ])
        .then((data) => {
          // Set Model values
          $scope.Model.availableImports = _.filter(
            $scope.Model.allImports,
            (i) => i?.type === $scope.Model.importType
          );
          $scope.list.setOrderBy('-timeStamp');
          $scope.list.setData($scope.Model.availableImports);
          $scope.Model.availableMergeFields = data[0];
          $scope.Model.availableWorkflows = data[1];
          $scope.Model.availableAccounts = data[2];
          $scope.Model.import = angular.copy($scope.Model.blankImport);
          $scope.Model.mergeFieldsProperties = _.flatten(
            _.map($scope.Model.availableMergeFields, 'value')
          );
        })
        .then(() => {
          // Declare Model as Ready and start rendering the page
          $scope.Model.isImportReady = true;
          if (isNote || isJob || isAccount) {
            $scope.Model.isUploadReady = true;
          }
        });
    };

  $scope.toggleWorkflow = () => {
    $scope.Model.isUploadReady = true;
  };

  $scope.back = () => {
    $scope.Model.isReady = true;
    $scope.Model.isImportReady = false;
  };

    /*
     * Methods available in Controller Scope
     * --------------------------------------------------------------------------------
     */
    $scope.mapDataFields = ($event, importItem) => {
      $event.stopPropagation();
      $scope.Model.isUploadReady = false;
      if (
        $scope.Model.importType === 'note' ||
        $scope.Model.importType === 'job' ||
        $scope.Model.importType === 'account' ||
        ($scope.Model.importType === 'ticketAndContact' &&
          $scope.Model.import?.workflow?.id &&
          _.isUuid($scope.Model.import?.workflow?.id))
      ) {
        $scope.Model.isImportReady = false;
        importService
          .readImport({ uploadedFile: importItem.file })
          .then((data) => {
            if (data?.importSample?.length) {
              $scope.Model.import.id = importItem.id;
              $scope.Model.importSampleTitle = data?.importSample[0]?.header || 'N/A';
              $scope.Model.importSampleData = data?.importSample[0]?.data[0] || null;
              $scope.Model.importData = data?.importSample[0]?.data || [];
              $scope.Model.import.name = importItem?.name || 'N/A';
              $scope.Model.import.file = importItem?.file || null;
              $scope.Model.import.type = $scope.Model.importType;
              $scope.mappingData($scope.Model.importSampleData);
              $scope.Model.activeSection = 1;
            } else {
              $scope.Model.import = angular.copy($scope.Model.blankImport);
              uiService.toast({
                text: {
                  p1: `File ${importItem.name}`,
                  p2: 'is corrupted',
                  p3: 'and cannot be added'
                },
                warn: true
              });
            }
          })
          .then(() => {
            uiService.scopeApply(() => {
              $scope.Model.isImportReady = true;
            }, 500);
          });
      } else {
        uiService.toast({
          text: {
            p1: 'Import data to',
            p2: 'Workflow',
            p3: 'is not selected'
          },
          warn: true
        });
      }
    };

  $scope.previewAndFinish = () => {
    if (
      $scope.Model.importType === 'ticketAndContact' &&
      $scope.Model.import?.workflow?.id &&
      _.isUuid($scope.Model.import?.workflow?.id)
    ) {
      if ($scope.Model.activeSection === 1) {
        let ticketName = false;
        const personFirstName = {
          person1: false,
          person2: true,
          person3: true,
          person4: true,
          person5: true
        };
        const personFamilyName = {
          person1: false,
          person2: true,
          person3: true,
          person4: true,
          person5: true
        };
        const personFullName = {
          person1: false,
          person2: true,
          person3: true,
          person4: true,
          person5: true
        };
        const personName = {
          person1: false,
          person2: true,
          person3: true,
          person4: true,
          person5: true
        };
        let companyName = false;

        const len = $scope.Model.mappableFields?.length || 0;
        for (let i = 0; i < len; i += 1) {
          if (
            $scope.getFirstPartOfFieldName($scope.Model.mappableFields[i]?.name || '', 0) ===
              'Deal' &&
            $scope.Model?.import?.ticket?.indexOf($scope.Model.mappableFields[i]) === -1
          ) {
            $scope.Model.import.ticket.push($scope.Model.mappableFields[i]);
          } else if (
            ($scope.getFirstPartOfFieldName($scope.Model.mappableFields[i]?.name || '', 0) ===
              'Person 1' ||
              $scope.getFirstPartOfFieldName($scope.Model.mappableFields[i]?.name || '', 0) ===
                'Person 2' ||
              $scope.getFirstPartOfFieldName($scope.Model.mappableFields[i]?.name || '', 0) ===
                'Person 3' ||
              $scope.getFirstPartOfFieldName($scope.Model.mappableFields[i]?.name || '', 0) ===
                'Person 4' ||
              $scope.getFirstPartOfFieldName($scope.Model.mappableFields[i]?.name || '', 0) ===
                'Person 5') &&
            $scope.Model.import?.person?.indexOf($scope.Model.mappableFields[i]) === -1
          ) {
            $scope.Model.import.person.push($scope.Model.mappableFields[i]);
          } else if (
            $scope.getFirstPartOfFieldName($scope.Model.mappableFields[i]?.name || '', 0) ===
              'Company' &&
            $scope.Model.import?.company?.indexOf($scope.Model.mappableFields[i]) === -1
          ) {
            $scope.Model.import.company.push($scope.Model.mappableFields[i]);
          }
        }

          if ($scope.Model.import?.ticket?.length) {
            ticketName = _.some(
              $scope.Model.import.ticket,
              (item) => item.mappableKey === 'name'
            );
          } else {
            ticketName = true;
          }
          if ($scope.Model.import?.person?.length) {
            const pLen = $scope.Model.import?.person?.length || 0;
            for (let p = 0; p < pLen; p += 1) {
              const count = _.add(p, 1);
              const mName = `Person ${count}`;
              personFirstName[`person${count}`] = _.some(
                $scope.Model.import.person,
                (item) =>
                  $scope.getFirstPartOfFieldName(item?.name || '', 0) === mName &&
                  item.mappableKey === 'person.information.firstName'
              );
              personFamilyName[`person${count}`] = _.some(
                $scope.Model.import.person,
                (item) =>
                  $scope.getFirstPartOfFieldName(item?.name || '', 0) === mName &&
                  item.mappableKey === 'person.information.familyName'
              );
              personFullName[`person${count}`] = _.some(
                $scope.Model.import.person,
                (item) =>
                  $scope.getFirstPartOfFieldName(item?.name || '', 0) === mName &&
                  item.mappableKey === 'person.information.fullName'
              );
              if (!personFirstName && !personFamilyName && !personFullName) {
                personName[`person${count}`] = false;
              } else {
                personName[`person${count}`] = true;
              }
            }
          } else {
            for (let p = 0; p < 5; p += 1) {
              const count = _.add(p, 1);
              personName[`person${count}`] = true;
            }
          }
          if ($scope.Model.import?.company?.length) {
            companyName = _.some(
              $scope.Model.import.company,
              (item) => item.mappableKey === 'company.information.name'
            );
          } else {
            companyName = true;
          }

          if (
            !ticketName ||
            !personName.person1 ||
            !personName.person2 ||
            !personName.person3 ||
            !personName.person4 ||
            !personName.person5 ||
            !companyName
          ) {
            $scope.Model.activeSection = 1;
            uiService.toast({
              text: {
                p1: 'Fields',
                p2: 'deal name, person first name and surname or full name and/or company name',
                p3: 'are required'
              },
              warn: true
            });
          } else {
            $scope.Model.importLimitTo =
              $scope.Model.importData.length < 3
                ? $scope.Model.importData.length
                : $scope.Model.importLimitTo;
            $scope.Model.activeSection = 2;
          }
        }
      } else if ($scope.Model.importType === 'note') {
        const len = $scope.Model.mappableFields?.length || 0;
        for (let n = 0; n < len; n += 1) {
          if ($scope.Model.import?.note?.indexOf($scope.Model.mappableFields[n]) === -1) {
            $scope.Model.import.note.push($scope.Model.mappableFields[n]);
          }
        }
        const noteContent = _.some(
          $scope.Model.import?.note || [],
          (item) => item.mappableKey === 'content'
        );
        const noteDealTitle = _.some(
          $scope.Model.import?.note || [],
          (item) => item.mappableKey === 'dealTitle'
        );
        if (!noteContent || !noteDealTitle) {
          $scope.Model.activeSection = 1;
          uiService.toast({
            text: {
              p1: 'Fields',
              p2: 'note content and deal title',
              p3: 'are required'
            },
            warn: true
          });
        } else {
          $scope.Model.importLimitTo =
            $scope.Model.importData.length < 3
              ? $scope.Model.importData.length
              : $scope.Model.importLimitTo;
          $scope.Model.activeSection = 2;
        }
      } else if ($scope.Model.importType === 'job') {
        const len = $scope.Model.mappableFields?.length || 0;
        for (let j = 0; j < len; j += 1) {
          if ($scope.Model.import?.job?.indexOf($scope.Model.mappableFields[j]) === -1) {
            $scope.Model.import.job.push($scope.Model.mappableFields[j]);
          }
        }
        const jobName = _.some(
          $scope.Model.import?.job || [],
          (item) => item.mappableKey === 'name'
        );
        const jobAssignedTo = _.some(
          $scope.Model.import?.job || [],
          (item) => item.mappableKey === 'idAssignedTo'
        );
        const jobDueDate = _.some(
          $scope.Model.import?.job || [],
          (item) => item.mappableKey === 'absoluteDueDate'
        );
        if (!jobName || !jobAssignedTo || !jobDueDate) {
          $scope.Model.activeSection = 1;
          uiService.toast({
            text: {
              p1: 'Fields',
              p2: 'task title, assigned to and due date',
              p3: 'are required'
            },
            warn: true
          });
        } else {
          $scope.Model.importLimitTo =
            $scope.Model.importData.length < 3
              ? $scope.Model.importData.length
              : $scope.Model.importLimitTo;
          $scope.Model.activeSection = 2;
        }
      } else if ($scope.Model.importType === 'account') {
        const len = $scope.Model.mappableFields?.length || 0;
        for (let j = 0; j < len; j += 1) {
          if ($scope.Model.import?.account?.indexOf($scope.Model.mappableFields[j]) === -1) {
            $scope.Model.import.account.push($scope.Model.mappableFields[j]);
          }
        }
        const accountFirstName = _.some(
          $scope.Model.import?.account || [],
          (item) => item.mappableKey === 'user.firstName'
        );
        const accountLastName = _.some(
          $scope.Model.import?.account || [],
          (item) => item.mappableKey === 'user.lastName'
        );
        const accountEmail = _.some(
          $scope.Model.import?.account || [],
          (item) => item.mappableKey === 'user.eMail'
        );
        const accountCountry = _.some(
          $scope.Model.import?.account || [],
          (item) => item.mappableKey === 'user.address.country'
        );
        if (!accountFirstName || !accountLastName || !accountEmail || !accountCountry) {
          $scope.Model.activeSection = 1;
          uiService.toast({
            text: {
              p1: 'Fields',
              p2: 'user first name, surname, email and country',
              p3: 'are required'
            },
            warn: true
          });
        } else {
          $scope.Model.importLimitTo =
            $scope.Model.importData.length < 3
              ? $scope.Model.importData.length
              : $scope.Model.importLimitTo;
          $scope.Model.activeSection = 2;
        }
      }
    };

  $scope.uploadFinished = (data) => {
    if (data && data[0]?.importSample?.length) {
      $scope.Model.import.id = data[0].importSample[0].id;
      $scope.Model.importSampleTitle = data[0].importSample[0].header;
      $scope.Model.importSampleData = data[0].importSample[0].data[0];
      $scope.Model.importData = data[0].importSample[0].data;
      $scope.Model.import.name = data[0].name;
      $scope.Model.import.file = data[0].file;
      $scope.Model.import.type = $scope.Model.importType;
      $scope.mappingData($scope.Model.importSampleData);
      $scope.Model.activeSection = 1;
      $scope.Model.isUploadReady = false;
    } else {
      uiService.toast({
        text: {
          p1: 'File',
          p2: data[0].name,
          p3: 'cannot be used'
        },
        warn: true
      });
    }
  };

  $scope.mappingData = (importData) => {
    let count = 0;
    _.forOwn(importData, (v, k) => {
      if (k) {
        const property = _.find(
          $scope.Model.mergeFieldsProperties,
          (f) =>
            f?.name.replace(/[^\w]/gi, '').toLowerCase() ===
            k.replace(/[^\w]/gi, '').toLowerCase()
        );

        if (property) {
          $scope.Model.mappableFields.push({
            id: count,
            name: property.name,
            mappableKey: property.key,
            originalKey: k,
            type: property.type,
            weight: property.weight
          });
        }
        count += 1;
      }
    });
  };

  $scope.getProperty = (idx) => _.find($scope.Model.mappableFields, (f) => f?.id === idx);

  $scope.addProperty = (binding, property, importFiled) => {
    if (binding) {
      $scope.Model.mappableFields.push({
        id: parseInt(binding.replace('property', '') || 0, 10),
        name: property.name,
        mappableKey: property.key,
        originalKey: importFiled,
        type: property.type,
        weight: property.weight
      });
    }
  };

  $scope.deleteProperty = (property) => {
    $scope.Model.mappableFields.splice($scope.Model.mappableFields.indexOf(property), 1);
  };

  $scope.getName = (idx) => {
    const property = $scope.getProperty(idx);
    if (property) {
      const name = property.name.split(' - ');
      return `<span class="name-first-part">${name[0]} - ${name[1]}:</span><span class="name-second-part">${name[2]}</span>`;
    }
    return null;
  };

  $scope.getFieldName = (property) => {
    if (property) {
      const field = _.find($scope.Model.mergeFieldsProperties, (f) => f?.key === property);
      return field?.name || 'N/A';
    }
    return null;
  };

  $scope.getFieldValue = (key, idx) => $scope.Model.importData[idx][key];

  $scope.getFirstPartOfFieldName = (name, idx) => {
    const parts = name.split(' - ');
    return parts[idx];
  };

  $scope.divideTitle = (name) => {
    if (name) {
      const title = name.split(' - ');
      return `<span class="title-first-part">${title[0]} - ${title[1]}:</span><span class="title-second-part">${title[2]}</span>`;
    }
    return '<span class="title-first-part">N/A:</span><span class="title-second-part">N/A</span>';
  };

  $scope.isDateFieldSelected = () =>
    _.some($scope.Model.mappableFields || [], (item) => item?.dateFormat !== '');

  $scope.isTimeFieldSelected = () =>
    _.some($scope.Model.mappableFields, (item) => item?.timeFormat !== '');

  $scope.startImport = ($event) => {
    $event.stopPropagation();
    $scope.Model.isReady = true;
    $scope.Model.isImportInProgress = true;
    $scope.Model.isImportReady = false;
    importService
      .createImport($scope.Model.import)
      .then((result) => {
        if (result.status) {
          importService.clearCache();
          $scope.reloadState();
        }
      })
      .catch(() => {
        $scope.reloadState();
      });
  };

  $scope.canRevert = ({ importItem }) => {
    if (importItem?.timeStampCompleted) {
      return dateTimeService
        .getMoment(importItem.timeStampCompleted)
        .add(2, 'days')
        .endOf('day')
        .isBefore(dateTimeService.getMoment(dateTimeService.epoch()));
    }
    return true;
  };

  $scope.getClass = ({ importItem }) => {
    const canRevert = dateTimeService
      .getMoment(importItem.timeStampCompleted)
      .add(2, 'days')
      .endOf('day')
      .isAfter(dateTimeService.getMoment(dateTimeService.epoch()));
    if (importItem?.isCompleted && !canRevert) {
      return 'archived';
    }
    return '';
  };

  $scope.revertImport = ($event, importItem) => {
    $event.stopPropagation();
    $mdDialog
      .show({
        targetEvent: $event,
        locals: {
          organizationName: $rootScope.CurrentOrganization.organization.name
        },
        template,
        controllerAs: '$ctrl',
        controller(organizationName) {
          const ctr = this;
          ctr.organizationName = '';
          ctr.isOrganizationNameEqual = () => {
            return ctr.organizationName.toLowerCase() === organizationName.toLowerCase();
          };
          ctr.confirm = () => {
            $mdDialog.hide();
          };
          ctr.cancel = () => {
            $mdDialog.cancel();
          };
        }
      })
      .then(() => {
        importService.revertImport({ id: importItem.id }).then((result) => {
          if (result.status) {
            importService.clearCache();
            uiService.toast({
              text: {
                p1: 'Reverting Imported data',
                p2: importItem.name,
                p3: 'please wait'
              },
              progress: true,
              delay: 2000
            });
            $scope.reloadState();
          } else {
            uiService.toast({
              text: {
                p1: 'Imported data for',
                p2: 'is in progress',
                p3: 'has not been deleted'
              },
              warn: true
            });
          }
        });
      });
  };

  $scope.deleteImport = ($event, importItem) => {
    $event.stopPropagation();
    const deleteTimeout = $timeout(() => {
      importService.deleteImport({ id: importItem.id }).then((result) => {
        if (result.status) {
          importService.clearCache();
          uiService.toast({
            text: {
              p1: 'File',
              p2: importItem.name,
              p3: 'has been deleted'
            },
            warn: true
          });
          $scope.reloadState();
        } else {
          uiService.toast({
            text: {
              p1: 'File',
              p2: importItem.name,
              p3: 'has not been deleted'
            },
            warn: true
          });
        }
      });
    }, 5250);
    uiService
      .toast({
        text: {
          p1: 'File',
          p2: importItem.name,
          p3: 'will be deleted'
        },
        warn: true,
        action: 'UNDO'
      })
      .then((action) => {
        if (action) {
          $timeout.cancel(deleteTimeout);
          uiService.toast({
            text: {
              p1: 'File',
              p2: importItem.name,
              p3: 'deletion undone'
            }
          });
        }
      });
  };

  $scope.download = ($event, importItem) => {
    $event.stopPropagation();
    importService.downloadUrl({
      file: importItem.file,
      name: importItem.name
    });
  };

  $scope.getDate = (importDate) => dateTimeService.getFormattedDate(importDate);

  $scope.getAccount = (idAccount) =>
    _.find($scope.Model.availableAccounts || [], (a) => a?.id === idAccount);

    $scope.previous = (section) => {
      $scope.Model.activeSection = section !== 0 ? section - 1 : section;
      if ($scope.Model.activeSection === 1) {
        $scope.Model.import.ticket = [];
        $scope.Model.import.person = [];
        $scope.Model.import.company = [];
        $scope.Model.import.note = [];
        $scope.Model.import.job = [];
        $scope.Model.import.account = [];
      }
    };

  $scope.reloadState = () => $state.reload();
};
